<template>
    <div class="dashboard-greeting vx-card mb-6">
        <div class="flex items-center justify-between flex-wrap gap-4">
            <div>
                <h2 class="text-2xl font-semibold text-gray-900">
                    {{ greeting }}, {{ userName }} 👋
                </h2>
                <p class="text-gray-500 text-sm mt-1">
                    <!-- LOREM -->
                </p>
            </div>

            <!-- <div class="flex gap-3 flex-wrap">
                <div class="summary-chip danger">
                    <span class="value">{{ highRiskCount }}</span>
                    <span class="label">Companies</span>
                </div>

                <div class="summary-chip warning">
                    <span class="value">{{ dueSoonCount }}</span>
                    <span class="label">Locations</span>
                </div>

                <div class="summary-chip success">
                    <span class="value">{{ complianceRate }}%</span>
                    <span class="label">Buildings</span>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    name: "DashboardGreeting",
    props: {
        userName: {
            type: String,
            default: "User"
        },
        highRiskCount: {
            type: Number,
            default: 0
        },
        dueSoonCount: {
            type: Number,
            default: 0
        },
        complianceRate: {
            type: Number,
            default: 0
        }
    },
    computed: {
        greeting() {
            const hour = new Date().getHours()
            if (hour < 12) return "Good morning"
            if (hour < 18) return "Good afternoon"
            return "Good evening"
        }
    }
}
</script>

<style scoped>
.dashboard-greeting {
    padding: 24px;
    border-radius: 14px;
}

/* summary chips */
.summary-chip {
    display: flex;
    flex-direction: column;
    padding: 10px 16px;
    border-radius: 10px;
    min-width: 90px;
    text-align: center;
    background: #f8fafc;
}

.summary-chip .value {
    font-weight: 700;
    font-size: 18px;
}

.summary-chip .label {
    font-size: 12px;
    color: #6b7280;
}

/* color variants */
.summary-chip.success {
    background: #ecfdf5;
    color: #059669;
}

.summary-chip.warning {
    background: #fffbeb;
    color: #d97706;
}

.summary-chip.danger {
    background: #fef2f2;
    color: #dc2626;
}
</style>